import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLocalStorage, setLocalStorage } from '../helpers/localStorage';

import es from './es.json';
import en from './en.json';

const savedLang = getLocalStorage('lang');
const fallback = 'es';
const initialLang = savedLang || (navigator.language?.startsWith('es') ? 'es' : 'en');

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    lng: initialLang,
    fallbackLng: fallback,
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', (lng) => {
  setLocalStorage('lang', lng);
});

export default i18n;
